// extracted by mini-css-extract-plugin
module.exports = {"storyBox":"StoryBox_storyBox__1DKJU","native":"StoryBox_native__vUXHF","teasersContainer":"StoryBox_teasersContainer__20WDY","separator":"StoryBox_separator__23sWd"};